// Centered/bottom-aligned modal. CSS at `.modal-backdrop` / `.modal-panel` —
// on mobile the panel goes full-screen via @media in payroll.css.
export default function Modal({ children, onClose, title, icon = 'ph-pencil-simple' }) {
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel" onClick={e => e.stopPropagation()}>
        <h3 className="panel-title">
          <span><i className={'ph ' + icon} /> {title}</span>
          <button className="btn-sm" onClick={onClose}>Close</button>
        </h3>
        {children}
      </div>
    </div>
  );
}
